import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/init',
      name: 'init',
      component: () => import('./views/Init.vue'),
      props: true,
    },
    {
      path: '/launcher',
      name: 'launcher',
      component: () => import('./views/Launcher.vue'),
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('./views/Home.vue'),
        },
        {
          path: '/contacts',
          name: 'contactsPage',
          component: () => import('./views/Modules/UsefulContacts/ContactsPage.vue'),
        },
        {
          path: '/messages',
          name: 'messagesPage',
          component: () => import('./views/Modules/MessagesPage/MessagesPage.vue'),
        },
        {
          path: '/signage',
          name: 'signagePage',
          component: () => import('./views/Modules/SignagePage/SignagePage.vue'),
        },
        {
          path: '/publicationsSlideshow',
          name: 'publicationsSlideshow',
          component: () => import('./views/Modules/PublicationsSlideshow/PublicationsSlideshow.vue'),
        },
        {
          path: '/weather',
          name: 'weather',
          component: () => import('./views/Modules/WeatherPage/WeatherPage.vue'),
        },
        {
          path: '/covid',
          name: 'covidPage',
          component: () => import('./views/Modules/CovidPage/CovidPage.vue'),
        },
        {
          path: '/video',
          name: 'videoPage',
          component: () => import('./views/Modules/VideoPage/VideoPage.vue'),
        },
      ],
    },
  ],
});
